<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :custom-class="`ubox-dialog ${isMobile ? 'ubox-dialog-mobile' : ''}`"
    append-to-body
    @closed="handleClosed"
    :before-close="handleBeforeClose"
    :show-close="!notClose"
    :close-on-click-modal="!notClose"
  >
    <div class="ubox-dialog-body">
      <div class="ubox-dialog-content">
        <slot></slot>
      </div>
      <div class="ubox-dialog-footer">
        <slot name="footer">
          <div
            class="btn"
            @click="handleCancel"
          >{{ buttonText?.[0] ?? '取消'}}</div>
          <div
            class="btn report"
            @click="handleConfirm"
          >{{ buttonText?.[1] ?? '确定'}}</div>
        </slot>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { isMobile } from "@/utils/common";
export default {
  name: "",
  props: {
    title:{
       type: String,
       default: '提示'
    },
    buttonText:{
      type: Array,
      default:function () {
        return []
      }
    },
    notClose:{
        type: Boolean,
        default: false
    }
  },
  computed: {
    isMobile() {
      return isMobile();
    }
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    handleCancel(e) {
      this.visible = false;
    },
    open() {
      this.visible = true;
    },
    close(){
      this.visible = false;
    },

    handleBeforeClose(done){
      if (!this.notClose) {
        done()
      }
    },

    handleClosed(e){
      this.$emit('closed')
      this.close();
    },
    handleConfirm() {
      this.$emit('confirm')
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-size: 20px;
  color: #1d1d1d;
  margin-bottom: 16px;
}
.tagContent {
  display: flex;
  flex-wrap: wrap;
  .tag {
    width: 166px;
    padding: 9px 0;
    text-align: center;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 3px;
    color: #646464;
    background: #f8f9fa;
    cursor: pointer;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &.curr {
      color: var(--primary-color);
      background: rgba(28, 189, 203, 0.1);
    }
  }
}

.ubox-dialog-footer {
   margin-top: 30px;
  .btn {
    width: 250px;
    color: #646464;
    font-size: 20px;
    font-weight: 600;
    border-radius: 3px;
    text-align: center;
    padding: 8px 0;
    cursor: pointer;
    background: #eeeeee;
    &.report {
      background: var(--primary-color);
      color: #ffffff;
    }
  }
}

.commentInput::v-deep {
  .el-textarea__inner {
    border: 0;
    padding: 16px;
    font-size: 18px;
    line-height: 27px;
    background: #f8f9fa;
  }
}

</style>

<style>
.ubox-dialog {
  /*width: fit-content !important;*/
  width: 590px;
  z-index: 11;
}
.ubox-dialog .el-dialog__body {
  padding: 30px;
}

.ubox-dialog .el-dialog__header {
  padding: 19px 0;
  text-align: center;
  border-bottom: 1px solid #ebeff2;
}

.ubox-dialog .el-dialog__header .el-dialog__title {
  color: #1d1d1d;
  font-size: 22px;
  font-weight: 500;
}

.ubox-dialog .el-dialog__header .el-dialog__headerbtn .el-icon-close {
  color: #444444 !important;
  font-size: 28px;
  font-weight: 500;
}
.ubox-dialog-mobile{
   width: 80vw;
}
.ubox-dialog-mobile .el-dialog__header{
    font-size: .14rem;
  }
  .ubox-dialog-mobile .ubox-dialog-footer .btn{
    width: 1.2rem;
    font-size: .14rem;
  }
</style>
